import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface SectionSaveActionsProps {
  onCancel: () => void;
  onSave: () => void;
  onSaveNew: () => void;
  disabled?: boolean;
  // Optional override for the main save button label (e.g. Update/Create).
  // Defaults to the existing 'save' i18n key.
  saveLabel?: ReactNode;
}

export const SectionSaveActions: FC<SectionSaveActionsProps> = (props) => {
  const { t } = useTranslation();
  const { onCancel, onSave, onSaveNew, disabled = false, saveLabel } = props;

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Button
        size="small"
        onClick={onCancel}
        variant="outlined"
        sx={{ mx: 1, color: '#8F16C8' }}
      >
        {t('cancel')}
      </Button>
      <Button
        size="small"
        disabled={disabled}
        onClick={onSaveNew}
        variant="outlined"
        sx={{ mx: 1, color: '#8F16C8' }}
      >
        {t('save_and_new')}
      </Button>
      <Button
        size="small"
        disabled={disabled}
        onClick={onSave}
        variant="contained"
        sx={{ mx: 1, backgroundColor: '#8F16C8' }}
      >
        {saveLabel ?? t('save')}
      </Button>
    </Box>
  );
};

SectionSaveActions.propTypes = {
  // @ts-ignore
  onCancel: PropTypes.func.isRequired,
  // @ts-ignore
  onSave: PropTypes.func.isRequired,
  // @ts-ignore
  onSaveNew: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  saveLabel: PropTypes.node
};
